export default __webpack_public_path__ + "static/media/CGV-CGU-Visibble.3ab8c31b.pdf";